import { render, staticRenderFns } from "./Dedomagements.vue?vue&type=template&id=64a9e9ac&"
import script from "./Dedomagements.vue?vue&type=script&lang=js&"
export * from "./Dedomagements.vue?vue&type=script&lang=js&"
import style0 from "./Dedomagements.vue?vue&type=style&index=0&id=64a9e9ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports